import axios from "axios";
import type { ColorCieLab } from "./color-math";

export interface NcsColor {
  name: string;
  lab: ColorCieLab;
}

export function loadNcsColors(): Promise<Array<NcsColor>> {
  return axios.get("/colors/ncs-colors.json").then((res) =>
    res.data.map((color: any) => ({
      name: color.name,
      lab: color.lab,
    })),
  );
}
